import { showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { userContactBookmarkConstants } from '../../constant';
import { exportAndDownloadExcel } from '../../../_helpers/exportAndDownloadFIle';
export const fetch_user_contacts_action = () => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.bookmarks.userContacts);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.FETCH_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const update_user_contact_action = (id, status) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.UPDATE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(`${config.bookmarks.contact}/${id}`, status);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.UPDATE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.UPDATE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

// action to create a new contacts
export const create_user_contact_action = (data) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.CREATE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.contact, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.CREATE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.CREATE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    return null;
  }
};

export const fetch_user_contact_details_action = (id) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(`${config.bookmarks.contact}/${id}`);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.FETCH_USER_CONTACT_DETAILS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const delete_user_contact_action = (id) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.DELETE_USER_CONTACT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(`${config.bookmarks.contact}/${id}`);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.DELETE_USER_CONTACT_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.DELETE_USER_CONTACT_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const fetch_all_admin_contacts_action = () => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.bookmarks.allAdminContact);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.FETCH_ALL_ADMIN_CONTACTS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

// action to export user contacts
export const export_user_contacts_action = (ids) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.EXPORT_USER_CONTACTS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.exportUserContacts, ids);
    if (response.status) {
      let data = response.data;
      exportAndDownloadExcel(data.data);
      dispatch({
        type: userContactBookmarkConstants.EXPORT_USER_CONTACTS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.EXPORT_USER_CONTACTS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const export_all_admin_contacts_action = () => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.EXPORT_ALL_ADMIN_CONTACTS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.exportAllAdminContacts);
    if (response.status) {
      let data = response.data;
      exportAndDownloadExcel(data.data);
      dispatch({
        type: userContactBookmarkConstants.EXPORT_ALL_ADMIN_CONTACTS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.EXPORT_ALL_ADMIN_CONTACTS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const export_selected_user_contacts_action = (export_ids) => async (dispatch) => {
  dispatch({
    type: userContactBookmarkConstants.EXPORT_SELECTED_USER_CONTACTS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.exportSelectedUserContacts, export_ids);
    if (response.status) {
      let data = response.data;
      exportAndDownloadExcel(data.data);
      dispatch({
        type: userContactBookmarkConstants.EXPORT_SELECTED_USER_CONTACTS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userContactBookmarkConstants.EXPORT_SELECTED_USER_CONTACTS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};
